import React, { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import Truncate from "react-truncate";

import { UnstyledButton } from "@sportal/cdk/unstyledButton/UnstyledButton";
import { isSBReportingLicensed } from "../../../../store/settings/settings.selectors";
import { Dropdown } from "../../../dropdown/Dropdown";
import { useOpenHistoryClearModal } from "./useOpenHistoryClearModal";
import { useIntlTranslate } from "../../../../hooks";
import { Icon } from "../../../icon/Icon";

import "./UserMenu.scss";

const UserMenu = ({ portalName, logout, subscriberName }) => {
  const translate = useIntlTranslate();
  const navigate = useNavigate();

  const isReportingLicensed = useSelector(isSBReportingLicensed);

  const pushHistoryItem = useCallback(
    (url) => {
      navigate(url);
    },
    [navigate]
  );

  const openHistoryClearModal = useOpenHistoryClearModal();

  const menuList = useMemo(
    () =>
      [
        {
          id: "menu_account",
          className: "account-item",
          content: <FormattedMessage id="account" />,
          action: () => pushHistoryItem("/settings/account"),
        },
        isReportingLicensed && {
          id: "menu_clear-data",
          content: <FormattedMessage id="clear_data" />,
          className: "menu-clear-data warning",
          action: () => openHistoryClearModal(),
        },
        portalName && {
          id: "menu_business-name",
          className: "menu-business-name",
          content: (
            <Truncate lines={3} width={160} trimWhitespace={true}>
              {portalName}
            </Truncate>
          ),
        },
        {
          id: "menu_logout",
          content: <FormattedMessage id="logout" />,
          action: () => logout(),
        },
      ].filter(Boolean),
    [
      isReportingLicensed,
      openHistoryClearModal,
      portalName,
      logout,
      pushHistoryItem,
    ]
  );

  return (
    <Dropdown
      className="user-menu"
      menuAriaLabel={translate("aria_primary_navigation")}
      toggleButton={
        <UnstyledButton className="user-menu__toggle">
          <span>{subscriberName}</span>
          <Icon icon="fa-regular fa-angle-down" />
        </UnstyledButton>
      }
      items={menuList}
      hiddenLabel={<FormattedMessage id="user_menu_label" />}
    />
  );
};

export default UserMenu;
